import React, { FunctionComponent } from 'react';
import { II18n } from '../../../models';
import { BrassButtonSharedV1, BrassButtonSharedPropsV1 } from './ButtonV1';
import { BrassIcon } from '../icon/Icon';
import { faComment } from '@fortawesome/free-solid-svg-icons';

const BrassButtonCommentV1: FunctionComponent<BrassButtonSharedPropsV1> = (
  props: BrassButtonSharedPropsV1,
) => (
  <BrassButtonSharedV1
    themeColor='primary'
    className='brass-button-comment'
    labelKey='comment'
    tooltipKey='clickToComment'
    translations={translations}
    icon={<BrassIcon icon={faComment} size='lg' />}
    {...props}
  />
);

const translations: II18n = {
  es: {
    comment: 'Comentar',
    clickToComment: 'Haga clic para comentar',
  },
  enUS: {
    comment: 'Comment',
    clickToComment: 'Click to comment',
  },
  ptBR: {
    comment: 'Comentar',
    clickToComment: 'Clique para comentar',
  },
};

export { BrassButtonCommentV1 };
